export const GET_LIST_HOPDONGCHODUYET = "GET_LIST_HOPDONGCHODUYET";
export const GET_LIST_HOPDONGCHODUYET_SUCCESS =
  "GET_LIST_HOPDONGCHODUYET_SUCCESS";
export const GET_LIST_HOPDONGCHODUYET_FAILURE =
  "GET_LIST_HOPDONGCHODUYET_FAILURE";

export const UPDATE_SEARCHTDATA_HOPDONGCHODUYET =
  "UPDATE_SEARCHTDATA_HOPDONGCHODUYET";
